export { default } from './SVG';